import { createSlice } from '@reduxjs/toolkit'
import { AllLeadsCountModel, Followup, Lead } from 'models/AllLeadsCountModel'
import { GetOpportunities, Opportunities } from 'models/OpprtunitiesModel'
export type InitalState = {
  dashboardData: AllLeadsCountModel
  leadsData: Followup
  opportunityData: GetOpportunities
}
const initialState = {
  dashboardData: {
    deploymentProgressLeads: {
      count: 0,
    },
    inReviewLeads: {
      count: 0,
    },
    liveLeads: {
      count: 0,
    },
    lostLeads: {
      count: 0,
    },
    newLeads: {
      count: 0,
    },
    assigned: {
      count: 0,
    },
    rejected: {
      count: 0,
    },
    revisits: {
      count: 0,
    },
    voicePods: {
      count: 0,
    },
    leads: {
      count: 0,
    },
    followup: {
      count: 0,
      leads: [],
    },
  },
  leadsData: {
    count: 0,
    leads: [],
  },
  opportunityData: {
    count: 0,
    opportunities: [],
  },
} as InitalState

export const homeSlice = createSlice({
  name: 'home',
  initialState: initialState,
  reducers: {
    getAllLeadsCount: (state, action) => {
      state.dashboardData = action.payload
      state.opportunityData.count = 0
      state.opportunityData.opportunities = []
      state.leadsData.count = 0
      state.leadsData.leads = []
    },
    getLeads: (state, action) => {
      state.leadsData.count = action.payload.leadList.count
      state.leadsData.leads = [...state.leadsData.leads, ...action.payload.leadList.leads]
    },
    clearLead: (state, action) => {
      state.leadsData.count = 0
      state.leadsData.leads = []
    },
    getOpprtunitiesByStatus: (state, action) => {
      if (action.payload.opportunityList.count) {
        state.opportunityData.count = action.payload.opportunityList.count
      }
      state.opportunityData.opportunities = [
        ...state.opportunityData.opportunities,
        ...action.payload.opportunityList.opportunities,
      ]
    },
    clearOpprtunities: (state, action) => {
      state.opportunityData.count = 0
      state.opportunityData.opportunities = []
    },
  },
})

export const { getAllLeadsCount, getLeads, getOpprtunitiesByStatus, clearLead, clearOpprtunities } =
  homeSlice.actions
export const homeData = (state) => state.home
export default homeSlice.reducer
